import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '2 - 2x3, 4 - 1x2',
  imageCount: 6,
  displayGroup: 'DG_WALLET',
  calc: (height) => {
    const psWidth = height / 4;
    const psHeight = psWidth * ASPECT_RATIO;
    const plWidth = height / ASPECT_RATIO / 2;
    const plHeight = height / 2;

    return {
      gridTemplate: `
        'p1 p2 p5 p6' ${psWidth}px
        'p3 p4 p5 p6' ${psWidth}px
        '. . . .' ${height / 2}px
        / ${psHeight}px ${psHeight}px ${plWidth}px ${plWidth}px`,
      photos: [...gridPhotos(1, 4, psWidth, psHeight, -90), ...gridPhotos(5, 6, plWidth, plHeight)]
    };
  }
};
